var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"ui avatar image",staticStyle:{"margin":"0","background-color":"#353535"},attrs:{"src":_vm.avatarImg,"title":_vm.userName}})}
var staticRenderFns = []

export { render, staticRenderFns }